import React, { useState } from 'react';
import { UserIcon, LockIcon } from 'lucide-react';
interface WebLoginProps {
  onLogin: () => void;
}
export function WebLogin({
  onLogin
}: WebLoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin();
  };
  return <div className="min-h-screen w-full flex items-center justify-center bg-gray-100 p-4" data-id="element-552">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-553">
        {/* Header */}
        <div className="px-8 pt-10 pb-8 flex flex-col items-center border-b border-gray-100" data-id="element-554">
          <img src="https://cdn.magicpatterns.com/uploads/wszHE4itFVKfiMMSe74Psk/logohospigen.png" alt="Logo HSJD" className="w-[200px] h-auto object-contain mb-6" data-id="element-555" />
          <h1 className="text-2xl font-bold text-center" style={{
          color: '#134073'
        }} data-id="element-556">
            Panel de Administración
          </h1>
          <p className="text-gray-500 mt-2 text-center" data-id="element-557">
            Lavandería Hospitalaria – HSJD
          </p>
        </div>

        {/* Form */}
        <div className="p-8" data-id="element-558">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-559">
            <div data-id="element-560">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-561">
                Correo Electrónico o Usuario
              </label>
              <div className="relative" data-id="element-562">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-563">
                  <UserIcon className="h-5 w-5 text-gray-400" data-id="element-564" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:outline-none transition-colors" style={{
                focusRingColor: '#3d99d2',
                focusBorderColor: '#3d99d2'
              }} placeholder="admin@hsjd.go.cr" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-565" />
              </div>
            </div>

            <div data-id="element-566">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-567">
                Contraseña
              </label>
              <div className="relative" data-id="element-568">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-569">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-570" />
                </div>
                <input type="password" className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:outline-none transition-colors" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-571" />
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-572">
              <div className="flex items-center" data-id="element-573">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-574" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-575">
                  Recordarme
                </label>
              </div>

              <div className="text-sm" data-id="element-576">
                <a href="#" className="font-medium hover:underline" style={{
                color: '#3d99d2'
              }} data-id="element-577">
                  ¿Olvidó su contraseña?
                </a>
              </div>
            </div>

            <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-bold text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all" style={{
            backgroundColor: '#134073',
            focusRingColor: '#134073'
          }} data-id="element-578">
              Ingresar al Sistema
            </button>
          </form>
        </div>

        <div className="bg-gray-50 px-8 py-4 border-t border-gray-100 text-center" data-id="element-579">
          <p className="text-xs text-gray-500" data-id="element-580">
            &copy; {new Date().getFullYear()} Hospital San Juan de Dios. Todos
            los derechos reservados.
          </p>
        </div>
      </div>
    </div>;
}